import { FC } from "react";

import ListagemUsuarioComponent from "./listagemUsuarioComponent";

const HomeUsuario: FC = () => {
  return <ListagemUsuarioComponent tipoUsuario="USUARIO" />;
};

export default HomeUsuario;
